<template>
  <v-row>
    <v-col cols="12" md="6" class="ma-0 pa-0 d-sm-none d-none d-md-flex">
      <div class="sign-three" style="position: relative"></div>
    </v-col>
    <v-col cols="12" md="6" class="ma-0 pa-0 login__wrapper">
  <div class="centered-container">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
    />
    <v-card class="md-elevation-3">
      <div class="title">
        <img src="/scrapingant-logo.png" />
        <p class="lg--text mb-0 fontweight400">Sign up</p>
        <p
          v-if="!signup_success"
          class="mb-0 xs--text line-height24 fontweight400"
        >
          Join ScrapingAnt to start using the most reliable Web Scraping Cluster
        </p>
      </div>

      <SocialLoginButtons
        v-if="!signup_success"
        class="actions social-actions"
      />

      <div class="title" v-if="signup_success">
        <p class="mb-0 xs--text line-height24 fontweight400">
          You've successfully registered at ScrapingAnt!
        </p>
        <br />
        <p class="mb-0 xs--text line-height24 fontweight400">
          Please, check your email <b>{{ form.body.email }}</b> for the
          confirmation letter.
        </p>
        <br />
        <p class="mb-0 xs--text line-height24 fontweight400">
          <b>Didn't receive the email?</b>
        </p>
        <p class="mb-0 xs--text line-height24 fontweight400">
          Check the <b>spam</b> folder of your email box or click on
          <b>Resend email</b> button to receive it again.
        </p>
      </div>

      <div v-if="signup_success" class="actions">
        <v-row class="justify-space-between ma-0">
          <v-col class="pa-0">
            <v-btn color="font" :to="{ name: 'Login' }">Log in</v-btn>
          </v-col>
          <v-col class="pa-0" align="end">
            <v-btn
              color="primary"
              :disabled="confirmation_resent"
              @click="resend"
              >Resend email</v-btn
            >
          </v-col>
        </v-row>
      </div>

      <div
        v-if="confirmation_resent"
        class="confirmation-message"
        style="margin-top: 20px"
      >
        <div>
          Confirmation email have been resent. Please, contact us by
          <a href="mailto:support@scrapingant.com">support@scrapingant.com</a>
          if email was not received.
        </div>
      </div>

      <div
        v-if="!signup_success"
        class="form"
        v-on:keyup.enter="registerOnEnter"
      >
        <v-col class="pa-0 mb-6">
          <v-text-field
            v-model="$v.form.body.email.$model"
            :error-messages="emailErrors"
            @input="$v.form.body.email.$touch()"
            @blur="$v.form.body.email.$touch()"
            autofocus
            required
            label="E-mail"
          ></v-text-field>
        </v-col>
        <v-col class="pa-0 mb-6">
          <v-text-field
            v-model="$v.form.body.password.$model"
            :type="showNewPassword ? 'text' : 'password'"
            :error-messages="newPasswordErrors"
            :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @input="$v.form.body.password.$touch()"
            @click:append="showNewPassword = !showNewPassword"
            label="Password"
          ></v-text-field>
        </v-col>
        <v-col class="pa-0">
          <v-text-field
            v-model="$v.form.body.repeated_password.$model"
            :type="showPasswordOneMoreTime ? 'text' : 'password'"
            :error-messages="OneMoreTimePasswordErrors"
            :append-icon="showPasswordOneMoreTime ? 'mdi-eye' : 'mdi-eye-off'"
            @input="$v.change_password.new_password_repeated.$touch()"
            @blur="$v.change_password.new_password_repeated.$touch()"
            @click:append="showPasswordOneMoreTime = !showPasswordOneMoreTime"
            label="Password one more time"
          ></v-text-field>
        </v-col>

        <v-col >
          <v-checkbox
              v-model="acceptedTOS"
              :rules="[v => !!v || 'You must accept the terms']"
          >
            <template v-slot:label>
              <span >I accept the
                <a
                    href="https://scrapingant.com/legal/terms-of-use/"
                    @click.stop
                    target="_blank"
                    class="text-primary"
                >Terms of Use</a>
                and
                <a
                    href="https://scrapingant.com/legal/privacy-policy/"
                    @click.stop
                    target="_blank"
                    class="text-primary">
                  Privacy Policy
                </a>
              </span>
            </template>
          </v-checkbox>
        </v-col>

         <vue-recaptcha :sitekey="constants.RECAPTCHA_SITE_KEY" @verify="captcha_verify"></vue-recaptcha>

        <span class="form-error">{{ form.error }}</span>
      </div>

      <div v-if="!signup_success" class="actions">
        <v-row class="justify-space-between ma-0">
          <v-col class="pa-0">
            <v-btn color="font" :to="{ name: 'Login' }">Log in</v-btn>
          </v-col>
          <v-col class="pa-0" align="end">
            <v-btn color="primary" :disabled="isDisabledForm || !acceptedTOS" @click="register"
              >Sign up</v-btn
            >
          </v-col>
        </v-row>
      </div>

      <div class="loading-overlay" v-if="loading">
        <v-progress-circular
          :size="50"
          :width="2"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-card>
  </div>
    </v-col>
  </v-row>
</template>

<script>
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import constants from "@/config/constants";
import SocialLoginButtons from "@/views/SocialLoginButtons";
import { VueRecaptcha } from 'vue-recaptcha';
import {getCookie} from "@/utils/common_utils";

export default {
  name: "Signup",
  components: { SocialLoginButtons, VueRecaptcha },
  data() {
    return {
      constants,
      loading: false,
      signup_success: false,
      confirmation_resent: false,
      captcha_response: null,
      showPasswordOneMoreTime: false,
      showNewPassword: false,
      acceptedTOS: false,
      form: {
        body: {
          email: "",
          password: "",
          repeated_password: "",
        },
        error: "",
      },
    };
  },
  validations: {
    form: {
      body: {
        email: {
          required,
          email,
        },
        password: {
          required,
          minLength: minLength(6),
        },
        repeated_password: {
          required,
          sameAsPassword: sameAs("password"),
        },
      },
    },
  },
  computed: {
    OneMoreTimePasswordErrors() {
      const errors = [];
      if (!this.$v.form.body.repeated_password.$dirty) return errors;
      !this.$v.form.body.repeated_password.required &&
        errors.push("Passwords not match :(");
      !this.$v.form.body.repeated_password.sameAsPassword &&
        errors.push("Passwords not match :(");
      return errors;
    },
    newPasswordErrors() {
      const errors = [];
      if (!this.$v.form.body.password.$dirty) return errors;
      !this.$v.form.body.password.required &&
        errors.push("Please, enter password with length of 6 symbols or more");
      !this.$v.form.body.password.minLength &&
        errors.push("Please, enter password with length of 6 symbols or more");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.form.body.email.$dirty) return errors;
      !this.$v.form.body.email.email &&
        errors.push("Please, enter correct email");
      !this.$v.form.body.email.required &&
        errors.push("Please, enter correct email");
      return errors;
    },
    isDisabledForm() {
      return (
        this.$v.form.body.email.$error ||
        this.$v.form.body.password.$error ||
        this.$v.form.body.repeated_password.$error ||
        !this.$v.form.body.email.$dirty ||
        !this.$v.form.body.repeated_password.$dirty ||
        !this.$v.form.body.password.$dirty ||
        !this.captcha_response
      );
    },
  },
  methods: {
    errors(res) {
      this.form.error =
        res.data?.error?.msg ?? "Error occurred. Please, try again.";
    },

    register() {
      this.$gtag.event(constants.ANALYTICS_EVENTS.SIGN_UP);
      const userSource = getCookie('user_source');
      this.loading = true;
      this.$store
        .dispatch("auth/register", {
           ...this.form.body,
          'user_source': userSource ? userSource : 'direct',
          'recaptcha-token': this.captcha_response
        })
        .then(
          // eslint-disable-next-line no-unused-vars
          (success) => {
            this.loading = false;
            this.signup_success = true;
          },
          (res) => {
            this.loading = false;
            this.errors(res.response);
          }
        );
    },
    captcha_verify(response) {
      this.captcha_response = response;
    },
    registerOnEnter() {
      if (!this.isDisabledForm) {
        this.register();
      }
    },

    resend() {
      this.$gtag.event(constants.ANALYTICS_EVENTS.RESEND_EMAIL, {
        event_category: constants.ANALYTICS_EVENTS.DEFAULT_CATEGORY,
      });
      this.loading = true;
      this.$store.dispatch("auth/resend_email", this.form.body.email).then(
        // eslint-disable-next-line no-unused-vars
        (success) => {
          this.loading = false;
          this.confirmation_resent = true;
        },
        (res) => {
          this.loading = false;
          this.errors(res.response);
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
.centered-container {
  .social-actions {
    margin-bottom: 20px;
  }
}
</style>
